<template>
  <div>
    <custom-table
      ref="customTable"
      :columns="columns"
      :sums="sums"
      :custom-view="customView"
      :footer-actions="footerActions"
      api-url="/order/v1/list"
      download-file-name="danh-sach-don-hang.xlsx"
      table-height="calc(100vh - 145px)"
      @downloadExcel="downloadExcel"
      @showDialogOrder="showDialogOrder"
    ></custom-table>
    <!-- api-download-url="/order/v1/list-export" -->

    <v-dialog v-model="orderDialog" max-width="480px">
      <DetailDialog
        v-if="orderDialog && order && order.id"
        :order="order"
        :is-show-exchange="true"
        @close="hideDialogOrder"
        @onOrderChanged="onOrderChanged"
      />
    </v-dialog>
  </div>
</template>

<script>
import {
  CUSTOM_VIEW,
  ORDER_CHANNELS,
  ORDER_CONTRACT_TYPES,
  ORDER_STATUSES,
  YES_NO_OPTIONS,
  // ORDER_CLASSIFIES,
} from "@/libs/const";
import moment from "moment";
import { httpClient } from "@/libs/http";

export default {
  name: "Index",
  components: {
    DetailDialog: () => import("@/components/exchange/DetailDialog"),
  },
  data: () => ({
    columns: [],
    sums: [],
    customView: CUSTOM_VIEW.ORDER_LIST,
    taxStatusOptions: [],
    sourceOptions: [],
    ceOptions: [],
    billOptions: [],
    yesNoOptions: [],
    footerActions: [],
    orderDialog: false,
    order: {},
  }),
  created() {
    const columns = [
      {
        type: "date-range-filter",
        label: this.$t("Thời gian"),
        placeholder: this.$t("Thời gian"),
        name: "created_at",
        hasSort: false,
        sortName: "created_at",
        key: "created_at",
        required: true,
        defaultValue: [
          moment().format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ],
      },
      {
        type: "select-branch",
        label: this.$t("Cơ sở xử lý"),
        placeholder: this.$t("Cơ sở xử lý"),
        name: "id_branch",
        hasSort: false,
        sortName: "id_branch",
        key: "branch_code",
        required: true,
      },
      {
        type: "input-filter",
        label: this.$t("Tracking"),
        placeholder: this.$t("Tracking"),
        name: "tracking_id",
        hasSort: false,
        sortName: "tracking_id",
        key: "tracking_id",
        required: true,
        action: "showDialogOrder",
      },
      {
        type: "input-filter",
        label: this.$t("Mã xe"),
        placeholder: this.$t("Mã xe"),
        name: "asset_uid_name",
        hasSort: false,
        sortName: "asset_uid_name",
        key: "asset_uid_name",
        required: true,
      },
      {
        type: "select-employee",
        label: this.$t("NV. Tạo"),
        placeholder: this.$t("NV. Tạo"),
        name: "id_account",
        hasSort: false,
        sortName: "account_name",
        key: "account_name",
        required: true,
      },
      {
        type: "select-filter",
        label: this.$t("Kênh"),
        placeholder: this.$t("Kênh"),
        name: "id_channel",
        hasSort: false,
        sortName: "id_channel",
        key: "id_channel",
        options: [...ORDER_CHANNELS],
        required: true,
      },
      /* {
        type: "input-filter",
        label: this.$t("Nguồn đơn"),
        placeholder: this.$t("Nguồn đơn"),
        name: "source_name",
        hasSort: false,
        sortName: "source_name",
        key: "source_name",
        options: [],
        required: true,
      }, */
      {
        type: "select-marketing-source",
        label: this.$t("MKT"),
        placeholder: this.$t("MKT"),
        name: "id_marketing_source",
        hasSort: false,
        sortName: "marketing_source_tracking",
        key: "marketing_source_tracking",
        options: [],
        required: true,
      },
      /* {
        type: "select-city",
        label: this.$t("Tỉnh thành"),
        placeholder: this.$t("Tỉnh thành"),
        name: "id_city",
        hasSort: false,
        sortName: "city_name",
        key: "city_name",
        required: true,
        clearable: true,
        customValueClass: "text-capitalize",
      }, */
      {
        type: "select-filter",
        label: this.$t("Hợp đồng"),
        placeholder: this.$t("Hợp đồng"),
        name: "contract_type",
        hasSort: false,
        sortName: "contract_type",
        key: "contract_type",
        options: [...ORDER_CONTRACT_TYPES],
        required: true,
      },
      {
        type: "select-filter",
        label: this.$t("Trạng thái"),
        placeholder: this.$t("Trạng thái"),
        name: "status",
        hasSort: false,
        sortName: "status",
        key: "status",
        options: [...ORDER_STATUSES],
        required: true,
      },
      {
        type: "input-filter",
        label: this.$t("Khách hàng"),
        placeholder: this.$t("Khách hàng"),
        name: "customer_name",
        hasSort: false,
        sortName: "customer_name",
        key: "customer_name",
        required: true,
      },
      {
        type: "input-filter",
        label: this.$t("Kênh LL"),
        placeholder: this.$t("Kênh LL"),
        name: "contact_channel_name",
        hasSort: false,
        sortName: "contact_channel_name",
        key: "contact_channel_name",
        required: true,
      },
      {
        type: "input-filter",
        label: this.$t("T. Tin"),
        placeholder: this.$t("T. Tin"),
        name: "customer_contact_name",
        hasSort: false,
        sortName: "customer_contact_name",
        key: "customer_contact_name",
        required: true,
        component: "QrLink",
      },
      /* {
        type: "select-filter",
        label: this.$t("Phân loại"),
        placeholder: this.$t("Phân loại"),
        name: "classify",
        hasSort: false,
        sortName: "classify",
        key: "classify",
        options: [...ORDER_CLASSIFIES],
        required: true,
      }, */
      /* {
        type: "input-filter-from-to",
        label: this.$t("Đặt cọc"),
        placeholder: this.$t("Đặt cọc"),
        name: "deposit_payment",
        hasSort: false,
        sortName: "deposit_payment",
        key: "deposit_payment",
        required: false,
      }, */
      {
        type: "input-filter-from-to",
        label: this.$t("Dịch vụ"),
        placeholder: this.$t("Dịch vụ"),
        name: "service_amount",
        hasSort: false,
        sortName: "service_amount",
        key: "service_amount",
        required: false,
      },
      {
        type: "input-filter-from-to",
        label: this.$t("Giao xe"),
        placeholder: this.$t("Giao xe"),
        name: "delivery_amount",
        hasSort: false,
        sortName: "delivery_amount",
        key: "delivery_amount",
        required: false,
      },
      {
        type: "input-filter-from-to",
        label: this.$t("Giảm giá"),
        placeholder: this.$t("Giảm giá"),
        name: "discount_amount",
        hasSort: false,
        sortName: "discount_amount",
        key: "discount_amount",
        required: false,
      },
      {
        type: "input-filter-from-to",
        label: this.$t("Quá hạn"),
        placeholder: this.$t("Quá hạn"),
        name: "overdue_amount",
        hasSort: false,
        sortName: "overdue_amount",
        key: "overdue_amount",
        required: false,
      },
      {
        type: "input-filter-from-to",
        label: this.$t("Bồi thường"),
        placeholder: this.$t("Bồi thường"),
        name: "indemnify_amount",
        hasSort: false,
        sortName: "indemnify_amount",
        key: "indemnify_amount",
        required: false,
      },
      {
        type: "input-filter-from-to",
        label: this.$t("Doanh thu"),
        placeholder: this.$t("Doanh thu"),
        name: "total_amount",
        hasSort: false,
        sortName: "total_amount",
        key: "total_amount",
        required: true,
      },
      {
        type: "input-filter-from-to",
        label: this.$t("Hoa hồng"),
        placeholder: this.$t("Hoa hồng"),
        name: "commission",
        hasSort: false,
        sortName: "commission",
        key: "commission",
        required: true,
      },
      /* {
        type: "input-filter-from-to",
        label: this.$t("Tiền mặt"),
        placeholder: this.$t("Tiền mặt"),
        name: "cash_payment",
        hasSort: false,
        sortName: "cash_payment",
        key: "cash_payment",
        required: false,
      }, */
      {
        type: "input-filter-from-to",
        label: this.$t("Chuyển khoản"),
        placeholder: this.$t("Chuyển khoản"),
        name: "bank_transfer_payment",
        hasSort: false,
        sortName: "bank_transfer_payment",
        key: "bank_transfer_payment",
        required: false,
      },
      {
        type: "input-filter-from-to",
        label: this.$t("Quẹt thẻ"),
        placeholder: this.$t("Quẹt thẻ"),
        name: "card_payment",
        hasSort: false,
        sortName: "card_payment",
        key: "card_payment",
        required: false,
      },
      {
        type: "input-filter-from-to",
        label: this.$t("Sạc"),
        placeholder: this.$t("Sạc"),
        name: "count_charger",
        hasSort: false,
        sortName: "count_charger",
        key: "count_charger",
        required: false,
      },
      {
        type: "input-filter-from-to",
        label: this.$t("Mũ"),
        placeholder: this.$t("Mũ"),
        name: "count_helmet",
        hasSort: false,
        sortName: "count_helmet",
        key: "count_helmet",
        required: false,
      },
      /* {
        type: "input-filter-from-to",
        label: this.$t("Khóa"),
        placeholder: this.$t("Khóa"),
        name: "count_lock",
        hasSort: false,
        sortName: "count_lock",
        key: "count_lock",
        required: false,
      },
      {
        type: "input-filter-from-to",
        label: this.$t("Áo mưa"),
        placeholder: this.$t("Áo mưa"),
        name: "count_raincoat",
        hasSort: false,
        sortName: "count_raincoat",
        key: "count_raincoat",
        required: false,
      }, */
      {
        type: "input-filter-from-to",
        label: this.$t("Giờ vượt"),
        placeholder: this.$t("Giờ vượt"),
        name: "overdue_hour",
        hasSort: false,
        sortName: "overdue_hour",
        key: "overdue_hour",
        required: false,
      },
      {
        type: "select-filter",
        label: this.$t("Upload thanh toán"),
        placeholder: this.$t("Upload thanh toán"),
        name: "is_image_paid",
        hasSort: false,
        sortName: "is_image_paid",
        key: "is_image_paid",
        required: false,
        options: [...YES_NO_OPTIONS],
      },
    ];
    this.columns = [...columns];

    const sums = [
      {
        text: "Đơn hàng",
        key: "total",
      },
      /* {
        text: "Doanh thu",
        key: "total_amount",
      }, */
      {
        text: "Hoa hồng",
        key: "commission",
      },
    ];
    this.sums = [...sums];

    const footerActions = [
      {
        text: "Excel",
        action: "downloadExcel",
        permissions: ["e_order_excel"],
        color: "success",
        class: "",
      },
    ];
    this.footerActions = [...footerActions];
  },
  methods: {
    async showDialogOrder(order) {
      const { data } = await httpClient.post("/order/v1/get-detail", {
        id_order: order.id,
      });
      this.order = { ...data };
      this.orderDialog = true;
    },

    refreshCustomTable() {
      this.$refs.customTable.getList();
    },

    onOrderChanged() {
      this.showDialogOrder(this.order);
      this.refreshCustomTable();
    },

    hideDialogOrder() {
      this.order = {};
      this.orderDialog = false;
    },

    downloadExcel(filters) {
      const filename = `emove-don-hang-${this.generateRandomString(5)}.xlsx`;
      this.downloadExcelFile("/order/v1/list-export", filters, filename);
    },
  },
};
</script>
